import { render, staticRenderFns } from "./registratiSpid.vue?vue&type=template&id=5bf81c3c"
import script from "./registratiSpid.vue?vue&type=script&lang=js"
export * from "./registratiSpid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports